<template>
  <div id="hotel-amenity" class="grid">
    <div class="grid-title">
      <h4>{{ $t("EXTENSION") }}</h4>
      <v-btn color="primary" class="pl-10 pr-10" @click="save">{{
        $t("SAVE")
      }}</v-btn>
    </div>
    <div class="grid-body p-3 border-top-unset">
      <div v-for="(group, groupIndex) in data" :key="group.id">
        <hr v-if="groupIndex" />
        <label class="label-title"
          >{{ group.i18ns.find(x => x.lang == defaultI18n).name }}
        </label>
        <v-row class="amenity-group">
          <v-col
            sm="6"
            md="4"
            v-for="amenity in group.amenities"
            :key="amenity.id"
            class="py-1"
          >
            <v-flex class="d-flex align-start amenity">
              <span
                :class="[
                  'icon-' +
                    amenity.i18ns
                      .find(x => x.lang == 'en')
                      .name.replace('(', '')
                      .replace(')', '')
                      .split(/[/&\s,]+/)
                      .join('-') +
                    '_ic',
                  amenityIcons.find(x => x.id == amenity.id)
                    ? amenityIcons.find(x => x.id == amenity.id).class
                    : ''
                ]"
              ></span>
              <v-checkbox
                :label="amenity.i18ns.find(x => x.lang == defaultI18n).name"
                color="indigo darken-3"
                class="m-0 pt-0"
                :value="amenity.id"
                v-model.lazy="installedAmenityIds[groupIndex].amenityIds"
              />
              <v-spacer />
              <div
                v-if="
                  installedAmenityIds[groupIndex].amenityIds &&
                    installedAmenityIds[groupIndex].amenityIds.includes(
                      amenity.id
                    )
                "
                class="am-btn fee"
                :class="{ free: amenity.free }"
                @click="amenity.free = !amenity.free"
              >
                {{ amenity.free ? $t("FREE") : $t("SURCHARGE") }}
              </div>
            </v-flex>
          </v-col>
        </v-row>
      </div>
      <hr/>
      <div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
        <label class="text-nowrap mr-2">{{
          $t("CHANNEL_APPLY")
        }}</label>
        <v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
          v-model="selectedOTAGlobal" chips multiple style="width: 270px;" disabled>
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
              <span>{{ item.text }}</span>
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
    </div>
  </div>
</template>
<script>
import { hotelAmenityService } from "@/_services/GeneralInfomation/extension.service.js";
import { systemService } from "@/_services/system-data.service.js";
import { AMENITIY_ICONS } from "@/_helpers/config.js";
import { _alert } from "@/_helpers/function.js";
export default {
  components: {},
  data() {
    return {
      lang: this.$i18n.locale,
      amenityIcons: AMENITIY_ICONS,
      data: [],
      installedAmenityIds: []
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='1']")
      .classList.add("v-tab--active");
  },
  watch: {},
  methods: {
    async initialize() {
      await systemService.getAllHotelAmenity().then(res => {
        this.data = res.data;
        res.data.forEach(x => {
          this.installedAmenityIds.push({
            groupId: x.id,
            amenityIds: []
          });
        });
      });
      await hotelAmenityService.get().then(res => {
        res.data.forEach(x => {
          let groupId = x.id;
          this.installedAmenityIds.find(
            x => x.groupId == groupId
          ).amenityIds = x.amenities.map(x => x.id);

          x.amenities.forEach(x => {
            let id = x.id;
            this.data
              .find(x => x.id == groupId)
              .amenities.find(x => x.id == id).free = x.free;
          });
        });
      });
    },
    save() {
      let data = [];
      this.installedAmenityIds.forEach(x => {
        let groupId = x.groupId;
        data = data.concat(
          x.amenityIds.map(x => {
            let amenityId = x;
            return {
              id: x,
              free: this.data
                .find(x => x.id == groupId)
                .amenities.find(x => x.id == amenityId).free
            };
          })
        );
      });
      let temp = data.map(x => {
        return {
          id: x.id,
          free: x.free
        };
      });
      hotelAmenityService.update(temp).then(res => {
        localStorage.setItem("GeneralInfomation", JSON.stringify({ tab: 1 }));
        _alert(res, this.$t(res.data));
      });
    }
  }
};
</script>
